export default "__VITE_ASSET__PBxHaSrF__"